import { FC } from 'react';

import { Grid } from '@mui/material';

import { IOperationIndustryProps as IProps } from './types';
import { IndustryDropdown } from '../IndustryDropdown/IndustryDropdown';
import { IndustryGroupDropdown } from '../IndustryGroupDropdown/IndustryGroupDropdown';
import { SectorDropdown } from '../SectorDropdown/SectorDropdown';
import { SubSectorDropdown } from '../SubSectorDropdown/SubSectorDropdown';

export const OperationIndustry: FC<IProps> = ({
  disabled,
  sectorId,
  subSectorId,
  industryGroupId,
  industryId,
}) => (
  <Grid container spacing={3}>
    <SectorDropdown disabled={disabled} id={sectorId} />
    <SubSectorDropdown disabled={disabled} id={subSectorId} />
    <IndustryGroupDropdown disabled={disabled} id={industryGroupId} />
    <IndustryDropdown disabled={disabled} id={industryId} />
  </Grid>
);
